export const SPLIT_PAYMENT_LABEL = 'Mechanizm podzielonej płatności';
